export default __webpack_public_path__ + "static/media/total-value.18e28d29.svg";